
@if (true) {
  <div>
    @if (!isLoading) {
      <div class="main-container" data-cy="claim-management">
        <div class="section-header" data-cy="claim-management-header">
          <div class="section-header-title" data-cy="claim-management-title">Manage Claims</div>
        </div>
        <div style="display: flex; padding-right: 10px; align-items: center; height: 24px; position: absolute; right: 0; top: 56px; width: 290px; z-index: 20;" data-cy="claim-management-filter-container">
          <div style="padding-right: 10px" data-cy="claim-management-filter-label">
            Filter By:
          </div>
          <div style="position: relative;" data-cy="claim-management-status-filter-container">
            <mat-form-field style="width:200px; position: absolute; top: -25px;" floatLabel='never' data-cy="claim-management-status-filter-field">
              <mat-label data-cy="claim-management-status-filter-label">Claim Status</mat-label>
              <mat-select [(value)]="this.enumClaimStatusFilter"
                (selectionChange)="filterByClaimStatus($event)" data-cy="claim-management-status-filter-select">
                @for (status of this.claimStatuses; track status) {
                  <mat-option [value]="status.ValidValueItemId" data-cy="claim-management-status-filter-option-{{status.ValidValueItemId}}">
                    {{ status.ItemDisplayValue }}
                  </mat-option>
                }
              </mat-select>
            </mat-form-field>
          </div>
        </div>
        <div style="flex: 1; overflow-y: auto; margin-top: 2px; padding: 0 10px 10px 10px; height: 670px" data-cy="claim-management-table-container">
          <tdo-table [dataSource]="dataClaims"
            [isMultiSelection]="false" [isSearchable]="true" [isUsePaginator]="true"
            [searchPredicate]="searchPredicate" (rowSelected)="onRowSelected($event)" data-cy="claim-management-table">
            <tdo-table-column displayName="Claim #" propertyName="TDOClaimNumber" isSortable="true" [rowTemplate]="claimNumber" data-cy="claim-management-column-claim-number">
              <ng-template #claimNumber let-row>
                <!--          <div *ngIf="row.TDOClaimNumber"></div>-->
                {{ row.TDOClaimNumber }}
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Method" propertyName="enumClaimMethod" isSortable="false" [rowTemplate]="method" data-cy="claim-management-column-method">
              <ng-template #method let-row>
                <mat-form-field class="insurance-select" style="width:100px" floatLabel='never' data-cy="claim-management-method-field">
                  <mat-label data-cy="claim-management-method-label">Method</mat-label>
                  <mat-select [(value)]="row.model.enumClaimMethodID" (selectionChange)="saveClaimMethod(row.ARClaimID, $event)" data-cy="claim-management-method-select">
                    @for (method of this.claimMethods; track method) {
                      <mat-option [value]="method.ValidValueItemId" data-cy="claim-management-method-option-{{method.ValidValueItemId}}">
                        {{ method.ItemDisplayValue }}
                      </mat-option>
                    }
                  </mat-select>
                </mat-form-field>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="First Name" propertyName="PatientFirstName" isSortable="true" [rowTemplate]="patientFirstName" data-cy="claim-management-column-first-name">
              <ng-template #patientFirstName let-row>
                @if (row.PatientFirstName) {
                  <div data-cy="claim-management-patient-first-name">{{ row.PatientFirstName }}</div>
                }
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Last Name" propertyName="PatientLastName" isSortable="true" [rowTemplate]="patientLastName" data-cy="claim-management-column-last-name">
              <ng-template #patientLastName let-row>
                @if (row.PatientLastName) {
                  <div data-cy="claim-management-patient-last-name">{{ row.PatientLastName }}</div>
                }
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Doctor" propertyName="DoctorFullName" isSortable="true" [rowTemplate]="doctorFullName" data-cy="claim-management-column-doctor">
              <ng-template #doctorFullName let-row>
                @if (row.model.DoctorFullName) {
                  <div data-cy="claim-management-doctor-full-name">{{ row.model.DoctorFullName }}</div>
                }
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Insurance" propertyName="PatientInsuranceName" isSortable="true" [rowTemplate]="insurance" data-cy="claim-management-column-insurance">
              <ng-template #insurance let-row>
                @if (row.model.PatientInsuranceName) {
                  <div data-cy="claim-management-insurance-name">{{ row.model.PatientInsuranceName }}</div>
                }
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Created" propertyName="ClaimDate" isSortable="true" [rowTemplate]="createdOn" data-cy="claim-management-column-created">
              <ng-template #createdOn let-row>
                @if (row.model.ClaimDate) {
                  <div data-cy="claim-management-claim-date">
                    {{ row.model.ClaimDate | date }}
                  </div>
                }
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Closed" propertyName="ClosedDate" isSortable="true" [rowTemplate]="closedOn" data-cy="claim-management-column-closed">
              <ng-template #closedOn let-row>
                @if (row.model.ClosedDate) {
                  <div data-cy="claim-management-closed-date">
                    {{ row.model.ClosedDate | date }}
                  </div>
                }
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Sent" propertyName="SentDate" isSortable="true" [rowTemplate]="sentOn" data-cy="claim-management-column-sent">
              <ng-template #sentOn let-row>
                @if (row.model.SentDate) {
                  <div data-cy="claim-management-sent-date">
                    {{ row.model.SentDate | date }}
                  </div>
                }
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Type" propertyName="ClaimType" isSortable="true" [rowTemplate]="claimType" data-cy="claim-management-column-type">
              <ng-template #claimType let-row>
                @if (row.model.ClaimType) {
                  <div data-cy="claim-management-claim-type">{{ row.model.ClaimType }}</div>
                }
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Location" propertyName="LocationName" isSortable="true" [rowTemplate]="locationName" data-cy="claim-management-column-location">
              <ng-template #locationName let-row>
                @if (row.model.LocationName) {
                  <div data-cy="claim-management-location-name">{{ row.model.LocationName }}</div>
                }
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Status" propertyName="ClaimStatus" isSortable="true" [rowTemplate]="claimStatus" data-cy="claim-management-column-status">
              <ng-template #claimStatus let-row>
                <div style="display: flex" data-cy="claim-management-status-container">
                  <div data-cy="claim-management-status-select-container">
                    <mat-form-field class="insurance-select" style="width:100px" floatLabel='never' data-cy="claim-management-status-field">
                      <mat-label data-cy="claim-management-status-label">Status</mat-label>
                      <mat-select [(value)]="row.model.enumClaimStatusID"
                        (selectionChange)="saveClaimStatus(row.ARClaimID, $event)" data-cy="claim-management-status-select">
                        <!--            <mat-select [(value)]="row.model.enumClaimStatusID"-->
                        <!--                        (selectionChange)="saveClaimStatus(row.ARClaimID, $event)"-->
                        <!--                        [disabled]="row.model.enumClaimStatusID != this.enumClaimStatusReadyToSend && row.model.enumClaimStatusID != this.enumClaimStatusPendingReview">-->
                        @for (status of this.claimStatuses; track status) {
                          <mat-option [value]="status.ValidValueItemId" data-cy="claim-management-status-option-{{status.ValidValueItemId}}">
                            {{ status.ItemDisplayValue }}
                          </mat-option>
                        }
                      </mat-select>
                    </mat-form-field>
                  </div>
                  @if (row.model.enumClaimMethodID === ClaimMethodEnum.APIDX) {
                    <div data-cy="claim-management-status-dx-button-container">
                      <button [disabled]="row.model.enumClaimStatusID !== this.enumClaimStatusSent" matTooltip="View status on DentalXChange" mat-icon-button color="primary" aria-label="View claim" (click)="this.openDXStatus(row.ARClaimID)" data-cy="claim-management-dx-status-btn">
                        <lucide-icon name="cloud-download" [size]="20" data-cy="claim-management-dx-status-icon"></lucide-icon>
                      </button>
                    </div>
                  }
                </div>
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="View" propertyName="ARClaimID" [rowTemplate]="claimView" data-cy="claim-management-column-view">
              <ng-template #claimView let-row>
                @if (row.model.ARClaimID) {
                  <div data-cy="claim-management-view-container">
                    <button matTooltip="View claim" mat-icon-button color="primary" aria-label="View claim" (click)="this.openClaim(row.model)" [disabled]="isOpeningClaim" data-cy="claim-management-view-btn">
                      <lucide-icon name="eye" [size]="20" data-cy="claim-management-view-icon"></lucide-icon>
                    </button>
                  </div>
                }
              </ng-template>
            </tdo-table-column>
            <tdo-table-column displayName="Check" propertyName="enumClaimCheckStatusID" [rowTemplate]="claimCheck" data-cy="claim-management-column-check">
              <ng-template #claimCheck let-row>
                @if (row.model.enumClaimCheckStatusID && row.model.ClaimStatus && row.model.enumClaimStatusID !== this.enumClaimStatusCancelled && row.model.enumClaimStatusID !== this.enumClaimStatusClosed) {
                  <div data-cy="claim-management-check-container">
                    <!--            <div *ngIf="row.model.enumClaimCheckStatusID && (row.model.ClaimStatus && !row.model.ClaimStatus.toLowerCase().contains('cancel'))">-->
                    @if (this.checkingClaimIds.has(row.model.ARClaimID)) {
                      <div data-cy="claim-management-check-loading">
                        <mat-spinner [diameter]="20" [matTooltip]="'Checking claim...'" data-cy="claim-management-check-spinner"></mat-spinner>
                      </div>
                    } @else {
                      @if (row.model.enumClaimCheckStatusID === this.enumClaimCheckStatusIDNotChecked) {
                        <div data-cy="claim-management-check-not-checked">
                          <button mat-icon-button color="primary" aria-label="Check Claim" (click)="this.checkClaim(row.model)" data-cy="claim-management-check-btn">
                            <lucide-icon name="receipt" [size]="20" style="color: var(--tdo-primary);" [matTooltip]="'Check claim'" data-cy="claim-management-check-icon"></lucide-icon>
                          </button>
                        </div>
                      }
                      @if (row.model.enumClaimCheckStatusID === this.enumClaimCheckStatusIDProblem) {
                        <div data-cy="claim-management-check-problem">
                          <button mat-icon-button color="primary" aria-label="Check Claim Failed" (click)="this.checkClaim(row.model)" data-cy="claim-management-check-failed-btn">
                            <lucide-icon name="alert-triangle" [size]="20" style="color: red;" [matTooltip]="'Check failed. Click to re-test'" data-cy="claim-management-check-failed-icon"></lucide-icon>
                          </button>
                        </div>
                      }
                    }
                    @if (row.model.enumClaimCheckStatusID === this.enumClaimCheckStatusIDPass) {
                      <div data-cy="claim-management-check-pass">
                        <lucide-icon name="check-circle" [size]="20" style="color: green;" [matTooltip]="'Check passed!'" data-cy="claim-management-check-pass-icon"></lucide-icon>
                      </div>
                    }
                  </div>
                }
              </ng-template>
            </tdo-table-column>
          </tdo-table>
        </div>
        <div style="display: flex" data-cy="claim-management-footer">
          <div style="flex: 1" data-cy="claim-management-legend">
            <img src="assets/icons/inspection.svg" alt="Check claim" style="width:20px;" [matTooltip]="'Check claim'" data-cy="claim-management-legend-check-icon">
            Check Claim
            <img src="assets/icons/important.svg" alt="Check Claim Failed" style="width:20px; margin-left: 10px" [matTooltip]="'Check failed, click to re-test'" data-cy="claim-management-legend-failed-icon">
            Check Failed
            <img src="assets/icons/checked.svg" alt="Check Claim Passed" style="width:20px; margin-left: 10px" [matTooltip]="'Check passed!'" data-cy="claim-management-legend-passed-icon">
            Check Passed
          </div>
          <div style="flex: 1" data-cy="claim-management-actions">
            <div style="float: right; padding-right: 20px" data-cy="claim-management-send-container">
              <button class="tdo-button primary-accent" aria-label="Send Claim(s)" (click)="this.sendClaims()" [disabled]="isSendingClaims" data-cy="claim-management-send-btn">
                Send Claim(s)
              </button>
          </div>
        </div>
      </div>
    </div>
  }
  @if (isLoading) {
    <div class="spinner-container" data-cy="claim-management-spinner-container">
      <mat-spinner data-cy="claim-management-spinner"></mat-spinner>
    </div>
  }
</div>
}
